import { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./helpers/scroll-top";
import PrivateRoute from "./routes/PrivateRoute";

import VerifyEmail from "./pages/other/VerifyEmail";
import ForgotPassword from "./pages/other/ForgotPassword";
import ResetPassword from "./pages/other/ResetPassword";

const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
const ShopGridFilter = lazy(() => import("./pages/shop/ShopGridFilter"));
const Product = lazy(() => import("./pages/shop-product/Product"));
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));
const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));
const PrivacyPolicy = lazy(() => import("./pages/other/PrivacyPolicy"));
const TermsConditions = lazy(() => import("./pages/other/TermsConditions"));
const Returns = lazy(() => import("./pages/other/Returns"));
const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  const BASE_PATH = process.env.PUBLIC_URL || "";
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="flone-preloader-wrapper">
        <div className="flone-preloader">
          <span></span>
          <span></span>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route path={`${BASE_PATH}/`} element={<HomeFashion />} />
            <Route path={`${BASE_PATH}/home-fashion`} element={<HomeFashion />} />

            <Route path={`${BASE_PATH}/shop-grid-filter`} element={<ShopGridFilter />} />
            <Route path="/product/:id" element={<Product />} />

            <Route path={`${BASE_PATH}/about`} element={<About />} />
            <Route path={`${BASE_PATH}/contact`} element={<Contact />} />
            <Route path={`${BASE_PATH}/privacy-policy`} element={<PrivacyPolicy />} />
            <Route path={`${BASE_PATH}/terms`} element={<TermsConditions />} />
            <Route path={`${BASE_PATH}/returns`} element={<Returns />} />

            <Route
              path={`${BASE_PATH}/my-account`}
              element={
                <PrivateRoute>
                  <MyAccount />
                </PrivateRoute>
              }
            />
            <Route path={`${BASE_PATH}/login-register`} element={<LoginRegister />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify" element={<VerifyEmail />} />

            <Route path={`${BASE_PATH}/cart`} element={<Cart />} />
            <Route path={`${BASE_PATH}/wishlist`} element={<Wishlist />} />
            <Route path={`${BASE_PATH}/compare`} element={<Compare />} />
            <Route path={`${BASE_PATH}/checkout`} element={<Checkout />} />

            <Route
              path="/account"
              element={<Navigate to={`${BASE_PATH}/my-account`} replace />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
